import { render, staticRenderFns } from "./CompanyDocumentsLayout.vue?vue&type=template&id=331a0c6e&scoped=true"
import script from "./CompanyDocumentsLayout.vue?vue&type=script&lang=ts"
export * from "./CompanyDocumentsLayout.vue?vue&type=script&lang=ts"
import style0 from "./CompanyDocumentsLayout.vue?vue&type=style&index=0&id=331a0c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331a0c6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
